import type { PaymentMethod, Transaction } from '../api/types'

/** A usable saved card: `setup` and not the removed/reset status 6. */
export function hasMethod(pm: PaymentMethod | null | undefined): boolean {
  return !!pm && Boolean(pm.setup) && Number(pm.status ?? 0) !== 6
}

export function paymentMethodTone(pm: PaymentMethod): string {
  return pm.hasError ? 'fs-panel--danger' : pm.hasWarning ? 'fs-panel--warning' : 'fs-panel--success'
}

/** Legacy per-type running totals (admin-user-transaction-list cards):
 * successful transactions only, summed PER CURRENCY from the backend's
 * `amountFormatted` strings. Summed in integer cents from the 2-decimal
 * string (never float addition), shown back with 2 decimals. */
export function sumSuccessfulByCurrency(rows: Transaction[], type: string): { currency: string; total: string }[] {
  const cents = new Map<string, bigint>()
  for (const t of rows) {
    if (Number(t.status) !== 1 || Number(t.result) !== 1 || t.type !== type) continue
    const m = /^(-?)(\d[\d,]*)(?:\.(\d{1,2}))?$/.exec(String(t.amountFormatted ?? '').trim())
    if (!m) continue
    const whole = BigInt(m[2]!.replace(/,/g, ''))
    const frac = BigInt((m[3] ?? '').padEnd(2, '0') || '0')
    const v = (whole * 100n + frac) * (m[1] ? -1n : 1n)
    const c = String(t.currency ?? '').toUpperCase()
    cents.set(c, (cents.get(c) ?? 0n) + v)
  }
  return [...cents.entries()].map(([currency, v]) => {
    const neg = v < 0n
    const abs = neg ? -v : v
    const whole = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return { currency, total: `${neg ? '-' : ''}${whole}.${(abs % 100n).toString().padStart(2, '0')}` }
  })
}
